/* ==========================================================================
   STIJL STUDIO — theme.js
   Vanilla JS, geen dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var focusTrapStack = [];

  /* ---------------------------------------------------------------------
     Helpers
     --------------------------------------------------------------------- */

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function lockScroll(lock) {
    document.body.classList.toggle('is-locked', lock);
  }

  function trapFocus(container) {
    var selectors =
      'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function handler(event) {
      if (event.key !== 'Tab') return;
      var focusable = $$(selectors, container).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', handler);
    focusTrapStack.push({ container: container, handler: handler });
  }

  function releaseFocus() {
    var entry = focusTrapStack.pop();
    if (entry) entry.container.removeEventListener('keydown', entry.handler);
  }

  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
    clearTimeout(el._timer);
    el._timer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        el.hidden = true;
      }, 450);
    }, 2600);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + amount;
  }

  /* ---------------------------------------------------------------------
     Drawers (menu, cart, search)
     --------------------------------------------------------------------- */

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.hidden = false;
    lockScroll(true);
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    trapFocus(drawer);
    var focusTarget = drawer.querySelector('[data-drawer-focus], input, button');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 120);
  }

  function closeDrawer(drawer) {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    releaseFocus();
    lockScroll(false);
    setTimeout(function () {
      drawer.hidden = true;
    }, 450);
  }

  function closeAllDrawers() {
    $$('[data-menu-drawer], [data-cart-drawer], [data-search-drawer]').forEach(closeDrawer);
  }

  document.addEventListener('click', function (event) {
    var openMenu = event.target.closest('[data-menu-open]');
    if (openMenu) {
      event.preventDefault();
      openDrawer($('[data-menu-drawer]'));
      return;
    }

    var openSearch = event.target.closest('[data-search-open]');
    if (openSearch) {
      event.preventDefault();
      openDrawer($('[data-search-drawer]'));
      return;
    }

    var openCart = event.target.closest('[data-cart-open]');
    if (openCart && window.cartType === 'drawer') {
      event.preventDefault();
      openDrawer($('[data-cart-drawer]'));
      return;
    }

    if (
      event.target.closest('[data-menu-close]') ||
      event.target.closest('[data-cart-close]') ||
      event.target.closest('[data-search-close]') ||
      event.target.classList.contains('menu-drawer__overlay') ||
      event.target.classList.contains('cart-drawer__overlay') ||
      event.target.classList.contains('search-drawer__overlay')
    ) {
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDrawers();
  });

  /* ---------------------------------------------------------------------
     Mobile submenu toggles
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-submenu-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var target = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!target) return;
    var isOpen = target.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* ---------------------------------------------------------------------
     Generieke modal (quick view, maattabel)
     --------------------------------------------------------------------- */

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    lockScroll(true);
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    trapFocus(modal);
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    releaseFocus();
    lockScroll(false);
    setTimeout(function () {
      modal.hidden = true;
    }, 400);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-modal-open]');
    if (opener) {
      event.preventDefault();
      openModal(document.getElementById(opener.dataset.modalOpen));
      return;
    }

    if (event.target.closest('[data-modal-close]') || event.target.classList.contains('modal__overlay')) {
      var open = document.querySelector('.modal.is-open');
      if (open) closeModal(open);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.modal.is-open');
    if (open) closeModal(open);
  });

  /* ---------------------------------------------------------------------
     Shop the look — hotspots
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-hotspot-toggle]');

    if (toggle) {
      event.preventDefault();
      var id = toggle.dataset.hotspotToggle;
      var panel = $('[data-hotspot-panel="' + id + '"]');
      var wasOpen = toggle.getAttribute('aria-expanded') === 'true';

      $$('[data-hotspot-toggle]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      $$('[data-hotspot-panel]').forEach(function (p) {
        p.classList.remove('is-open');
        p.hidden = true;
      });

      if (!wasOpen && panel) {
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
        });
      }
      return;
    }

    if (!event.target.closest('.shoplook__popover')) {
      $$('[data-hotspot-toggle]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      $$('[data-hotspot-panel]').forEach(function (p) {
        p.classList.remove('is-open');
        p.hidden = true;
      });
    }
  });

  /* ---------------------------------------------------------------------
     Quick view
     --------------------------------------------------------------------- */

  function resizeShopifyImage(url, width) {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_' + width + 'x$1$2');
  }

  function renderQuickView(product) {
    var modal = $('#QuickViewModal');
    if (!modal) return;
    var content = $('[data-quick-view-content]', modal);
    var image = product.featured_image || (product.images && product.images[0]);
    var firstVariant = product.variants[0];
    var hasOptions = product.variants.length > 1;

    var optionsHtml = '';
    if (hasOptions) {
      product.options.forEach(function (name, index) {
        var values = [];
        product.variants.forEach(function (v) {
          var val = v.options[index];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml +=
          '<div class="variant-option" data-qv-option data-option-index="' + index + '" style="margin-bottom:1rem;">' +
          '<div class="variant-option__label"><span>' + name + '</span></div>' +
          '<div class="variant-option__values">' +
          values
            .map(function (val) {
              var checked = firstVariant.options[index] === val ? ' checked' : '';
              return (
                '<label class="variant-pill"><input type="radio" name="qv-option-' +
                index +
                '" value="' +
                String(val).replace(/"/g, '&quot;') +
                '"' +
                checked +
                '>' +
                val +
                '</label>'
              );
            })
            .join('') +
          '</div></div>';
      });
    }

    content.innerHTML =
      '<div class="quick-view__media"><img src="' + resizeShopifyImage(image, 800) + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '"></div>' +
      '<div class="quick-view__body">' +
      (product.vendor ? '<div class="product__vendor">' + product.vendor + '</div>' : '') +
      '<h2 class="quick-view__title">' + product.title + '</h2>' +
      '<div class="price" data-qv-price style="margin-top:0.5rem;"><span class="price__sale">' + formatMoney(firstVariant.price) + '</span></div>' +
      optionsHtml +
      '<div class="product__buy-row" style="margin-top:1.25rem;">' +
      '<button type="button" class="btn" data-qv-add>' + window.themeStrings.addToCart + '</button>' +
      '</div>' +
      '<a href="' + product.url + '" class="section-header__link" style="margin-top:1.25rem; display:inline-block;">' +
      window.themeStrings.viewDetails +
      '</a>' +
      '</div>';

    var addButton = $('[data-qv-add]', content);
    var priceEl = $('[data-qv-price]', content);

    function currentVariant() {
      var selected = $$('[data-qv-option]', content).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
      return product.variants.find(function (v) {
        return selected.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    function updateVariant() {
      var variant = currentVariant();
      if (!variant) return;
      priceEl.innerHTML =
        '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
        (variant.compare_at_price > variant.price
          ? '<s class="price__regular">' + formatMoney(variant.compare_at_price) + '</s>'
          : '');
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      addButton.dataset.variantId = variant.id;
    }

    content.addEventListener('change', updateVariant);
    updateVariant();

    addButton.addEventListener('click', function () {
      var variant = currentVariant();
      if (!variant) return;
      addButton.disabled = true;

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) {
            toast(data.description || data.message);
            return;
          }
          return refreshCartUI().then(function () {
            closeModal(modal);
            if (window.cartType === 'drawer') openDrawer($('[data-cart-drawer]'));
          });
        })
        .catch(function () {
          toast('Er ging iets mis. Probeer opnieuw.');
        })
        .finally(function () {
          addButton.disabled = false;
        });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view]');
    if (!trigger) return;
    event.preventDefault();

    var modal = $('#QuickViewModal');
    if (!modal) return;
    var content = $('[data-quick-view-content]', modal);
    content.innerHTML = '<div class="quick-view__loading">…</div>';
    openModal(modal);

    fetch('/products/' + trigger.dataset.quickView + '.js')
      .then(function (response) { return response.json(); })
      .then(renderQuickView)
      .catch(function () {
        closeModal(modal);
        toast('Kon product niet laden.');
      });
  });

  /* ---------------------------------------------------------------------
     Productpagina — lightbox
     --------------------------------------------------------------------- */

  var lightbox = $('#ProductLightbox');
  var lightboxImages = $$('[data-lightbox-trigger]');

  if (lightbox && lightboxImages.length) {
    var lightboxImageEl = $('[data-lightbox-image]', lightbox);
    var lightboxIndex = 0;

    var showLightbox = function (i) {
      lightboxIndex = (i + lightboxImages.length) % lightboxImages.length;
      lightboxImageEl.src = lightboxImages[lightboxIndex].dataset.full;
      lightboxImageEl.alt = lightboxImages[lightboxIndex].alt || '';
    };

    lightboxImages.forEach(function (img, i) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () {
        showLightbox(i);
        lightbox.hidden = false;
        lockScroll(true);
        requestAnimationFrame(function () {
          lightbox.classList.add('is-open');
        });
        trapFocus(lightbox);
      });
    });

    var closeLightbox = function () {
      lightbox.classList.remove('is-open');
      releaseFocus();
      lockScroll(false);
      setTimeout(function () {
        lightbox.hidden = true;
      }, 400);
    };

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-lightbox-close]')) closeLightbox();
    });

    var prevBtn = $('[data-lightbox-prev]', lightbox);
    var nextBtn = $('[data-lightbox-next]', lightbox);
    if (prevBtn) prevBtn.addEventListener('click', function () { showLightbox(lightboxIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showLightbox(lightboxIndex + 1); });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
      if (event.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
    });
  }

  /* ---------------------------------------------------------------------
     Productpagina — beeldcarrousel op mobiel
     --------------------------------------------------------------------- */

  var mediaList = $('.product__media-list');
  var mediaDots = $('[data-media-dots]');

  if (mediaList && mediaDots) {
    var dots = $$('[data-media-dot]', mediaDots);

    var setActiveDot = function (index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    };

    var scrollTicking = false;
    mediaList.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          var width = mediaList.clientWidth;
          if (width > 0) {
            setActiveDot(Math.round(mediaList.scrollLeft / width));
          }
          scrollTicking = false;
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        mediaList.scrollTo({ left: mediaList.clientWidth * i, behavior: 'smooth' });
        setActiveDot(i);
      });
    });
  }

  /* ---------------------------------------------------------------------
     Hero — subtiele parallax
     --------------------------------------------------------------------- */

  var heroMedia = $('.hero__media img, .hero__media video');
  if (
    heroMedia &&
    window.innerWidth >= 750 &&
    window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  ) {
    var parallaxTicking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (parallaxTicking) return;
        parallaxTicking = true;
        requestAnimationFrame(function () {
          var offset = Math.min(window.scrollY * 0.15, 120);
          heroMedia.style.transform = 'translateY(' + offset + 'px) scale(1.08)';
          parallaxTicking = false;
        });
      },
      { passive: true }
    );
  }

  /* ---------------------------------------------------------------------
     Sticky header shadow
     --------------------------------------------------------------------- */

  var headerWrapper = $('[data-header-wrapper]');
  if (headerWrapper) {
    var onScroll = function () {
      headerWrapper.classList.toggle('is-stuck', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------------
     Announcement bar rotator
     --------------------------------------------------------------------- */

  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    var speed = parseInt(bar.dataset.speed, 10) || 5;
    var index = 0;
    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, speed * 1000);
  });

  /* ---------------------------------------------------------------------
     Sliders
     --------------------------------------------------------------------- */

  $$('[data-slider]').forEach(function (wrapper) {
    var track = $('[data-slider-track]', wrapper);
    var prev = $('[data-slider-prev]', wrapper);
    var next = $('[data-slider-next]', wrapper);
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  /* ---------------------------------------------------------------------
     Quantity inputs
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-button]');
    if (!button) return;
    var wrapper = button.closest('.quantity');
    var input = $('input', wrapper);
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    var value = button.dataset.quantityButton === 'plus' ? current + 1 : Math.max(min, current - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
     Variant selection
     --------------------------------------------------------------------- */

  $$('[data-product-form]').forEach(function (form) {
    var wrapper = form.closest('[data-product-wrapper]') || document;
    var dataEl = $('[data-variants]', wrapper);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = $('[data-variant-id]', form);
    var submit = $('[data-add-button]', form);
    var priceEl = $('[data-price-wrapper]', wrapper);
    var skuEl = $('[data-sku]', wrapper);
    var stockEl = $('[data-stock-note]', wrapper);

    function updateStockNote(variant) {
      if (!stockEl) return;
      var threshold = parseInt(stockEl.dataset.threshold, 10) || 0;
      var show =
        variant &&
        variant.available &&
        typeof variant.stock === 'number' &&
        variant.stock > 0 &&
        variant.stock <= threshold;
      stockEl.hidden = !show;
      if (show) {
        stockEl.textContent = window.themeStrings.lowStock.replace('[[count]]', variant.stock);
      }
    }

    function optionGroups() {
      return $$('[data-option-selector]', wrapper);
    }

    function selectedOptions() {
      return optionGroups().map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return options.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = findVariant(options);

      optionGroups().forEach(function (group) {
        var index = parseInt(group.dataset.optionIndex, 10);
        var label = $('[data-option-value]', group);
        var checked = $('input:checked', group);
        if (label && checked) label.textContent = checked.value;

        $$('.variant-pill', group).forEach(function (pill) {
          var input = $('input', pill);
          if (!input) return;
          var trial = options.slice();
          trial[index] = input.value;
          var match = findVariant(trial);
          pill.classList.toggle('variant-pill--unavailable', !match || !match.available);
        });
      });

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = window.themeStrings.unavailable;
        }
        updateStockNote(null);
        return;
      }

      updateStockNote(variant);

      if (idInput) idInput.value = variant.id;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }

      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
      if (skuEl) skuEl.textContent = variant.sku || '';

      if (variant.featured_media_id) {
        var media = wrapper.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (media) {
          if (window.innerWidth >= 990) {
            media.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            // Mobiel: carrousel horizontaal naar de juiste foto schuiven
            media.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    wrapper.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-selector]')) update();
    });

    update();
  });

  /* ---------------------------------------------------------------------
     Cart
     --------------------------------------------------------------------- */

  function refreshCartUI() {
    return fetch(window.routes.cart_url + '?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        ['[data-cart-contents]', '[data-cart-footer]'].forEach(function (selector) {
          var fresh = parsed.querySelector(selector);
          var current = $(selector);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      })
      .then(function () {
        return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;
    if (window.cartType !== 'drawer') return;

    event.preventDefault();
    var button = $('[data-add-button]', form);
    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = '…';
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          toast(data.description || data.message);
          return;
        }
        return refreshCartUI().then(function () {
          openDrawer($('[data-cart-drawer]'));
        });
      })
      .catch(function () {
        toast('Er ging iets mis. Probeer opnieuw.');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      });
  });

  function changeCartLine(key, quantity) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return refreshCartUI();
      });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeCartLine(remove.dataset.cartRemove, 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) return;
    changeCartLine(input.dataset.cartQuantity, quantity);
  });

  /* ---------------------------------------------------------------------
     Predictive search
     --------------------------------------------------------------------- */

  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  if (searchInput && searchResults) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var term = searchInput.value.trim();
      if (term.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      timer = setTimeout(function () {
        var url =
          window.routes.predictive_search_url +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var inner = parsed.querySelector('[data-predictive-results]');
            searchResults.innerHTML = inner ? inner.innerHTML : '';
          });
      }, 250);
    });
  }

  /* ---------------------------------------------------------------------
     Collection filters — auto submit
     --------------------------------------------------------------------- */

  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  });

  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------------------------------------------------------------------
     Aanbevolen producten (Product Recommendations API)
     --------------------------------------------------------------------- */

  $$('[data-recommendations]').forEach(function (container) {
    var url = container.dataset.url;
    if (!url || container.querySelector('.product-grid')) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          container.innerHTML = fresh.innerHTML;
          $$('.reveal', container).forEach(function (el) { el.classList.add('is-visible'); });
        }
      })
      .catch(function () {});
  });

  /* ---------------------------------------------------------------------
     Share button
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-share]');
    if (!button) return;
    var url = button.dataset.share || window.location.href;
    if (navigator.share) {
      navigator.share({ url: url, title: document.title }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        toast(window.themeStrings.copied);
      });
    }
  });

  /* ---------------------------------------------------------------------
     Scroll reveal
     --------------------------------------------------------------------- */

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    var observeAll = function () {
      $$('.reveal:not(.is-visible)').forEach(function (el) {
        if (!el.dataset.revealDelaySet) {
          var siblings = el.parentElement ? Array.prototype.slice.call(el.parentElement.children) : [];
          var index = siblings.indexOf(el);
          el.style.transitionDelay = Math.min(Math.max(index, 0), 5) * 70 + 'ms';
          el.dataset.revealDelaySet = 'true';
        }
        observer.observe(el);
      });
    };

    observeAll();
    document.addEventListener('shopify:section:load', observeAll);
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------------------------------------------------------------------
     Beelden zacht infaden zodra ze geladen zijn
     --------------------------------------------------------------------- */

  function bindImageFade(scope) {
    $$('img[loading="lazy"]:not(.card__image):not(.img-fade)', scope).forEach(function (img) {
      img.classList.add('img-fade');
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener(
          'load',
          function () {
            img.classList.add('is-loaded');
          },
          { once: true }
        );
        img.addEventListener(
          'error',
          function () {
            img.classList.add('is-loaded');
          },
          { once: true }
        );
      }
    });
  }

  bindImageFade(document);
  document.addEventListener('shopify:section:load', function (event) {
    bindImageFade(event.target || document);
  });

  /* ---------------------------------------------------------------------
     Sticky koopbalk op mobiel — verschijnt als de koopknop uit beeld is
     --------------------------------------------------------------------- */

  var stickyAtc = $('[data-sticky-atc]');
  var mainAddButton = $('.product__buy [data-add-button]');

  if (stickyAtc && mainAddButton && 'IntersectionObserver' in window) {
    stickyAtc.hidden = false;
    var atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyAtc.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );
    atcObserver.observe(mainAddButton);
  }

  window.themeUtils = { formatMoney: formatMoney, toast: toast, refreshCartUI: refreshCartUI };
})();
